<!-- главная (десктоп) -->
<template>
    <div class="ObjectList">
        <Object v-for="object of objects" v-bind="object" :key="object.id"/>
    </div>
</template>

<script>
import Object from '@/components/Object/Object'

export default {
    name: "ObjectList",
    components: {
        Object
    },
    props: {
        objects: Array,
    }
}
</script>

<style lang="scss">
    .ObjectListPage {
        padding-top: 30px;//130px;

        @include tablet {
            padding-top: 50px;
        }
    }

.ObjectList {

  .Object + .Object {
    margin-top: 24px;

    @include tablet {
      margin-top: 16px;
    }
  }

}
</style>